<template>
<div>
	<div class="main">
		<div class="main-container">
			<div class="header">
				<div class="tab">
					<span v-for="(item,index) in tabs" :key="item.id" :class="{active:index == num}" @click="tab(index)">{{item}}</span>
				</div>

				<div class="course">
					<div class="c-targ">{{ num == 0 ? '适用课程' : '适用图书' }}</div>
					<div class="item">
						<!-- <span class="tag">全部</span> -->
						<van-dropdown-menu>
							<van-dropdown-item v-bind:title="dropdownItemTitle" ref="item">
								<van-tree-select
									:items="couponsTypeList"
									:active-id.sync="activeId"
									:main-active-index.sync="activeIndex"
									@click-nav="onClickNav"
									@click-item="onClickItem"
								/>
							</van-dropdown-item>
						</van-dropdown-menu>
						<!-- <span class="tag" :class="item.id === tabActiveId ? 'current': ''" v-for="item in couponsTypeList" :key="item.id" @click="onCoupontTypeTab(item)">{{ item.name }}</span>
						<div class="tag-child" v-if="tabChildren.length > 0">
							<span :class="it.id == tabActiveId ? 'current': ''" v-for="it in tabChildren" :key="it.id+1" @click="onCoupontTypeTabChildren(it)">{{ it.name }}</span>
						</div> -->
					</div>
				</div>
			</div>
				<PullRefresh :listRef="$refs.list">
					<List
						ref="list"
						url="/api/app/coupon/list"
						method="get"
						:params="search"
						:alwaysShowPager="true"
						:on-getdata="onGetdata"
						:on-formatter="onFormatter"
					>
						<template slot="item">
							
								<div class="c-list" v-if="couponlist.length">
									<!-- <template> -->
										<div class="item" v-for="item in couponlist" :key="item.id">
											<div class="left">
												<div class="t" v-if="item.dis_type == 1">{{ item.scope_type == 1 ? '全部课程' : '指定课程'  }}</div>
												<div class="t" v-else-if="item.dis_type == 2">{{ item.scope_type == 1 ? '全部图书' : '指定图书' }}</div>
												<!-- <div class="t" v-if="item.scope_type == 1">全部课程可用</div>
												<div class="t" v-if="item.scope_type == 2">指定分类可用</div>
												<div class="t" v-if="item.scope_type == 3">指定课程可用</div> -->
												<!-- <div class="t" v-else>指定课程可用</div> -->
												<div class="money"><span>¥</span>{{ item.discounted_price }}</div>
											</div>
											<div class="middle">
												<div class="t">满 {{ item.full_reduction }} 元可用</div>
												<div class="text">
													<p v-if="item.valid_day == 0">{{ item.valid_start }}-{{ item.valid_end }}</p>
													<p v-else>领取后{{ item.valid_day }}天有效</p>
													<p><span v-if="item.restrict_num > 1">每人限领 {{ item.restrict_num }} 张 </span> 限量发行 {{ item.num }} 张</p>
												</div>
											</div>
											<div class="right">
												<div class="lq" v-if="item.is_can_get == 0" @click="clickReceive(item.id)">立即领取</div>
												<div class="ylq" v-if="item.is_can_get == 1">已领取</div>
											</div>
										</div>
									<!-- </template> -->
								</div>
						</template>
					</List>
				</PullRefresh>
		</div>
	</div>
</div>
</template>
<script>
import List from "../../components/mobile/List.vue";
export default {
	name: 'mIndex',
	components: {
		List
	},
	data() {
		return {
			tabs: ["课程", "图书"],
			courseTabs: ['指定', '通用'],
			num: 0,
			couponsTypeList: [
				{ id: -1, text: '指定', activeId:-1, children: []},
        { id: -2, text: '通用', activeId:-2, children: []}
			],
			dropdownItemTitle: '指定',
			tabChildren:[],
			couponlist: [],
			activeId: 1,
      activeIndex: 0,
			search: {
				dis_type: 1,
				commodity_id: '',
				scope_type: '2,3,4',
				parent_id: ''
			},
			active: 0,
			valid_value: '',
		}
	},
	watch: {
    $route() {
      this.$refs.list.searchRefresh();
    }
  },
	created() {
		this.getClassify(0)
	},
	methods: {
	
		onFormatter(rows){
			rows.forEach(i => {
				i.discounted_price = i.discounted_price / 100
        i.full_reduction = i.full_reduction / 100
				// i.valid_start = this.$pub.dislodgeZero(new Date(parseInt(i.valid_start) * 1000).format("yyyy/MM/dd"))
				// i.valid_end = this.$pub.dislodgeZero(new Date(parseInt(i.valid_end) * 1000).format("yyyy/MM/dd"))
				i.valid_end = this.$pub.tsToTime(i.valid_end, false)
				i.valid_start = this.$pub.tsToTime(i.valid_start, false)
			});
		},

		tab(index) {
				this.num = index
				this.couponsTypeList = [
					{ id: -1, text: '指定', activeId:-1, children: []},
        	{ id: -2, text: '通用', activeId:-2, children: []}
				]
				this.activeId = 1
      	this.activeIndex = 0
				this.dropdownItemTitle = '指定'
				
				if(index == 0){ // 课程
					this.search = {
						dis_type: 1,
						commodity_id: '',
						scope_type: '2,3,4',
						parent_id: ''
					}
				}
				if(index == 1){  // 图书					
					this.search = {
						dis_type: 2,
						commodity_id: '',
						scope_type: '2,3,4',
						parent_id: ''
					}
				}
				this.getClassify(index)
			
		},


		//
		async getClassify(index){
			console.log(index)
			let data = []
			if(index == 0){
				data = await this.$http.get('/api/app/course/classify')
			}
			if(index == 1){
				data = await this.$http.get('/api/app/book/classify')
			}
			data.forEach((item,index,array)=>{
				data[index].text = data[index].name
				data[index].activeId = data[index].id
				if(data[index].children && data[index].children.length>0){
					data[index].children.forEach((it,i,arr)=>{
						data[index].children[i].text = data[index].children[i].name
						data[index].children[i].activeId = data[index].children[i].id
						data[index].children[i].activeIndex = data[index].children[i].id
					})
				}
				this.couponsTypeList.push(data[index])
			})
			this.$refs.list.searchRefresh();
		},

		// 立即领取 
		async clickReceive(id){
			if(!localStorage.getItem('studentToken')){
				let url = process.env.VUR_APP_LOGING_URL + '/login?return_url=' + encodeURIComponent(window.location.href)
      	window.open(url, '_self')
			}
			await this.$http.get('/api/app/userGetCoupon/' + id)
			await this.$toast("领取成功，请到个人中心查看!");
			this.$refs.list.searchRefresh();
		},
		onGetdata(data) {
      this.couponlist = data;
    },
		onClickNav(index){
			
			this.dropdownItemTitle = this.couponsTypeList[index].text
			if(index == 0){ // 全部
				this.search = {
					dis_type: 1,
					commodity_id: '',
					scope_type: '2,3,4',
					parent_id: ''
				}
			}else if(index == 1){  // 指定				
				this.search = {
					dis_type: 1,
					commodity_id: '',
					scope_type: 1,
					parent_id: ''
				}
			}else{
				this.search.scope_type = '2,3,4'
				this.search.commodity_id = this.couponsTypeList[index].id
				this.search.parent_id = this.couponsTypeList[index].parent_id
			}
			if(this.num == 0){
				this.search.dis_type = 1
			}
			if(this.num == 1){
				this.search.dis_type = 2
			}
			if(this.couponsTypeList[index].children && this.couponsTypeList[index].children.length > 0){
				this.dropdownItemTitle = this.couponsTypeList[index].children[0].text
				this.search.commodity_id = this.couponsTypeList[index].children[0].id
				this.activeId = this.couponsTypeList[index].children[0].id
			}else{
				this.$refs.item.toggle()
			}
			this.$refs.list.searchRefresh()
		},
		onClickItem(data){
			this.dropdownItemTitle = data.text
			this.search.scope_type = '2,3,4'
			this.search.commodity_id = data.id
			this.search.parent_id = data.parent_id
			this.$refs.list.searchRefresh();
			this.$refs.item.toggle();
		},

	}

}
</script>
<style lang="scss" scoped>
	.main-container {
		.header {
			background: #fff;
			position: fixed;
			left: 0;
			right: 0;
			top: 0;
			z-index: 999;
		}
		.tab{
			display: flex;
    	justify-content: space-around;
			padding-top: 20px;
			span {
				font-weight: bold;
				margin-right: 30px;
				cursor: pointer;
				font-size: 15px;
    		height: 30px;
			}
		}
		.tab .active {
			border-bottom: 3px solid #E60012;
		}
		
		.course {
			margin-top: 20px;
			margin-left: 20px;
			font-size: 15px;
			display: flex;
			.c-targ {
				white-space: nowrap;
			}
			.c-targ .tag.current {
				background-color: #ff0036 !important;
				color: #fff;
			}
			.c-targ span {
				color: #333;
				padding: 0 10px;
				margin: 0 5px;
			}
			
			.item span {
				color: #333;
				padding: 0 10px;
				margin: 0 5px;
			}
		
			.item .tag.current {
				background-color: #ff0036 !important;
				color: #fff;
			}
			.tag-child {
				padding: 0 30px;
			}
			.tag-child span{
				height: 24px;
				border-radius: 5px;
				font-size: 15px;
				color: #333;
				line-height: 24px;
			}
			.tag-child span.current {
				background-color: #ff0036 !important;
				color: #fff;
			}
		}

		/deep/ .van-pull-refresh {
			margin-top: 113px;
		}
		/deep/ .van-dropdown-menu__bar {
			height: 40px;
			width: 125px;
			top: -10px;
			box-shadow:none;
		}

		.c-list {
			.none {
				text-align: center;
				margin: 100px auto;
				color: #999;
				font-size: 20px;
			}
			.none img{
				width: 280px;
			}
		  .item {
				height: 97px;
				background-image: url('~@/assets/img/img_bg_card.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				margin: 20px 26px;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			.item .left {
				margin-left: 17px;
				margin-top: -10px;
				.t {
					height: 16px;
					background: #ffffff;
					border-radius: 8px;
					font-size: 10px;
					color: #ee060d;
					padding: 3px 9px;
					display: inline-block;
				}
				.money {
					font-size: 26px;
					font-weight: 500;
					color: #ee060d;
					width: 90px;
					span {
						font-size: 22px;
					}
				}
			}
			.item .middle {
				flex:1;
				margin-top: 30px;
				margin-left: 4px;
				align-items: flex-start;
				transform: scale(0.9);
				margin-left: -8px;
				margin-bottom: 10px;
				.t {
					font-size: 16px;
					font-weight: 500;
					color: #ee060d;
				}
				.text {
					font-size: 10px;
					font-weight: 400;
					color: #222;
				}
				.text p {
					width: 100%;
					margin: 0;
					margin-top: 2px;
					white-space: nowrap;
    			letter-spacing: -1px;
				}
			}
			.item .right {
				width: 18px;
				margin-right: 16px;
				.lq {
					font-size: 16px;
					font-weight: 500;
					color: #e80209;
					padding: 13px 0px;
					line-height: 20px;
					cursor: pointer;
				}
				.ylq {
					font-size: 18px;
					font-weight: 500;
					color: #fff;
					padding: 20px 0px;
					line-height: 20px;
				}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/index.vue